import React from "react";
import { Link } from "react-router-dom";
import { Star, Check, Award, Heart, ArrowRight, MapPin } from "lucide-react";

const ROSA_AVATAR = "https://form-elec.fr/wp-content/uploads/2024/01/rosa-formelec-avatar-1.png";
const IMG_EMS_HOME = "https://form-elec.fr/wp-content/uploads/2024/01/electrostimulation-sante-bien-etre-fos-sur-mer-q25kwop8e24vvlfsu9aonanwfwreexwzrrto7r7n4e.jpg";

export default function LeCoach() {
  return (
    <div className="bg-white">
      {/* Hero */}
      <section className="bg-fegray-light pt-12 lg:pt-16 pb-16 lg:pb-20 px-6 lg:px-10" data-testid="coach-hero">
        <div className="max-w-7xl mx-auto text-center">
          <p className="text-fegreen font-medium uppercase tracking-[0.25em] text-xs mb-4">
            — Votre coach
          </p>
          <h1 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-fegray-dark">
            Rencontrez <span className="text-fegreen">Rosalie</span>
          </h1>
          <p className="mt-6 text-fegray max-w-2xl mx-auto">
            Coach sportive diplômée, spécialiste en électrostimulation à domicile.
          </p>
        </div>
      </section>

      <section className="py-16 lg:py-20 px-6 lg:px-10">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          <div className="lg:col-span-5 flex justify-center">
            <img src={ROSA_AVATAR} alt="Rosalie - Coach EMS" className="w-64 sm:w-80 lg:w-full max-w-md h-auto" />
          </div>
          <div className="lg:col-span-7">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-fegray-dark mb-6">
              Une coach. Un objectif. <span className="text-fegreen">Le vôtre.</span>
            </h2>
            <p className="text-fegray leading-relaxed mb-4">
              Patience, motivation et bonne humeur — chaque séance est conçue
              pour vous, dans le confort de votre domicile. Que vous souhaitiez
              perdre du poids, tonifier votre corps, soulager des douleurs ou
              préparer une compétition, je m&apos;adapte à votre rythme et à
              vos objectifs.
            </p>
            <p className="text-fegray leading-relaxed mb-8">
              J&apos;utilise la technologie allemande <span className="font-bold">MIHA BODYTEC</span>,
              standard professionnel utilisé en milieu sportif et médical
              depuis plus d&apos;une décennie, ainsi qu&apos;un impédancemètre
              professionnel <span className="font-bold">BODY COACH</span> pour
              suivre votre progression.
            </p>

            <div className="grid grid-cols-3 gap-3 sm:gap-4 mb-10">
              <Stat value="8+" label="ans d'expérience" />
              <Stat value="200+" label="clients suivis" />
              <Stat value="4.9★" label="note Google" />
            </div>

            <div className="flex flex-wrap gap-3">
              <Link to="/reservation" className="btn-green" data-testid="coach-reserve-btn">
                Réserver ma séance <ArrowRight className="w-4 h-4" />
              </Link>
              <Link to="/contact" className="btn-outline-green">
                Me contacter
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Photo séance */}
      <section className="px-6 lg:px-10">
        <div className="max-w-7xl mx-auto rounded-2xl lg:rounded-3xl overflow-hidden">
          <img src={IMG_EMS_HOME} alt="Séance d'EMS à domicile à Istres" className="w-full h-64 sm:h-80 lg:h-[500px] object-cover" />
        </div>
      </section>

      {/* Zones */}
      <section className="bg-fegray-light py-16 lg:py-20 px-6 lg:px-10 mt-16 lg:mt-20">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-fegray-dark">
              Zones d&apos;intervention
            </h2>
            <p className="text-fegreen font-medium mt-2">Istres &amp; Alentours</p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
            {["Istres", "Fos-sur-Mer", "Miramas", "Saint-Mitre-les-Remparts", "Port-de-Bouc"].map((z) => (
              <div key={z} className="fe-card p-5 sm:p-6 text-center">
                <MapPin className="w-6 h-6 text-fegreen mx-auto mb-3" />
                <div className="font-semibold text-fegray-dark text-sm sm:text-base">{z}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Engagements */}
      <section className="py-16 lg:py-20 px-6 lg:px-10">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-fegray-dark text-center mb-12 lg:mb-14">
            Mes engagements
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              { icon: Award, title: "Coach diplômée", text: "Certifications professionnelles, formations continues en EMS et nutrition sportive." },
              { icon: Heart, title: "Bienveillance", text: "Une approche humaine, patiente, sans jugement. On avance ensemble, à votre rythme." },
              { icon: Check, title: "Résultats prouvés", text: "Suivi rigoureux via application mobile, bilan régulier, objectifs adaptés et atteints." },
            ].map((b, i) => {
              const Icon = b.icon;
              return (
                <div key={i} className="text-center">
                  <div className="w-20 h-20 rounded-full bg-fegreen-light flex items-center justify-center mx-auto mb-5">
                    <Icon className="w-9 h-9 text-fegreen" strokeWidth={1.8} />
                  </div>
                  <h3 className="text-xl font-bold text-fegray-dark mb-3">{b.title}</h3>
                  <p className="text-fegray text-sm leading-relaxed">{b.text}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}

function Stat({ value, label }) {
  return (
    <div className="text-center">
      <div className="text-2xl sm:text-3xl font-extrabold text-fegreen">{value}</div>
      <div className="text-[10px] sm:text-xs text-fegray uppercase tracking-wider mt-1">{label}</div>
    </div>
  );
}
